<form #submitFeedbackForm="ngForm" (ngSubmit)="validateAndSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">Feedback</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
  </div>

  <div class="modal-body">
    <!-- Dynamic Properties -->
    @for (property of properties; track property.key) {
      <div class="mb-3">
        <app-property-input [property]="property" [(ngModel)]="feedbackCommand[property.key]" [name]="property.key">
        </app-property-input>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Annuleren</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="validateAndSubmit()"
      [disabled]="!hasRequiredFields() || !organizationId"
    >
      Feedback versturen
    </button>
  </div>
</form>
